export enum PaymentMethodTitle {
    responsive = 'Efectivo',
    directDebit = 'Débito directo' ,
    creditcard = 'Tarjeta de crédito',
    CommitmentToPayment = 'Pagaré',
    Ext_PaymentInKind = 'Pago en especies',
    GrainExchange = 'Canje de granos'
}
